import React from "react";
import { useAtomValue } from "jotai";
import { curCourse, curSessionIdAtom } from "../../../../store";
import { useSession } from "../../../../Utils/useSession";

import { useAtom } from "jotai";
import { Select, Spin } from "antd";
import { CourseListItem } from "../../../../types";

interface CourseSelectProps {
    courseList: CourseListItem[];
    loading: boolean;
    allowSelect: boolean;
}

export default function CourseSelect({
    allowSelect,
    courseList,
    loading
}: CourseSelectProps) {
    const curSessionId = useAtomValue(curSessionIdAtom);
    const { session } = useSession(curSessionId || "");
    const [course, setCourse] = useAtom(curCourse);

    if (!session) return null;

    function onSelect(value: string) {
        const course = courseList.find(
            item => `${item.courseNo}-${item.courseSeq}` === value
        );
        if (!course) return;
        setCourse(course);
    }

    if (loading) return <Spin spinning />;
    if (!courseList || !course) return null;
    if (courseList?.length && courseList.length <= 1) return null;
    //如果是从课程内容页发起的聊天，绑定那门课的课程信息，不可自行选择
    if (!allowSelect) return null;

    return (
        <Select
            size="small"
            value={`${course.courseNo}-${course.courseSeq}`}
            onSelect={onSelect}>
            {courseList.map(item => (
                <Select.Option
                    key={`${item.courseNo}-${item.courseSeq}`}
                    value={`${item.courseNo}-${item.courseSeq}`}>
                    {item.courseName}
                </Select.Option>
            ))}
        </Select>
    );
}
